/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaCloudflareTurnstileSiteVerifyInfo = {
    SCS?: SomniaCloudflareTurnstileSiteVerifyInfo.SCS;
    CHALTS?: string;
    HOSTNM?: string;
    ACTN?: string;
    CDATA?: string;
    MTDATA?: Record<string, string>;
};

export namespace SomniaCloudflareTurnstileSiteVerifyInfo {

    export enum SCS {
        Y = 'Y',
        N = 'N',
    }


}

